











import Vue, { PropOptions } from 'vue';
import ArrowRightIcon from './images/arrow-right.vue.svg';
import { IMenuItem } from './types';

export default Vue.extend({
  name: 'UserMenuMobileSubMenuProfileLinksItem',
  components: {
    ArrowRightIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    } as PropOptions<IMenuItem>,
  },
  computed: {
    icon(): string {
      return require(`./images/${this.item.icon}-icon.vue.svg`);
    },
    bindAttrs(): IMenuItem {
      if (this.item.href) {
        // @ts-ignore

        const target = this.item.href.includes('/salaries/') ? '' : '_blank';
        return { ...this.item, target, rel: 'nofollow noopener noreferrer' };
      }

      return this.item;
    },
    rootComponent(): string {
      if (this.item.to) {
        return 'NuxtLink';
      } else if (this.item.href) {
        return 'a';
      } else {
        return 'button';
      }
    },
  },
});
